// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import "flowbite/dist/flowbite.turbo.js";

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import "trix"
import "@rails/actiontext"
import "./trix_config"

const whitepaperTokenKey = "whitepaper_customer_token"
const whitepaperDownloadPath = new RegExp("^/whitepapers/[^/]+/download")

const appendTokenToWhitepaperLink = (link) => {
  const href = link.getAttribute("href")
  if (!href || href.startsWith("#")) return

  let url
  try {
    url = new URL(href, window.location.origin)
  } catch (error) {
    return
  }

  if (!whitepaperDownloadPath.test(url.pathname)) return

  const token = window.localStorage?.getItem(whitepaperTokenKey)
  if (!token || url.searchParams.get("token")) return

  url.searchParams.set("token", token)
  link.setAttribute("href", url.toString())
}

const applyTokenToWhitepaperLinks = () => {
  const token = window.localStorage?.getItem(whitepaperTokenKey)
  if (!token) return

  document.querySelectorAll("a[href]").forEach((link) => {
    appendTokenToWhitepaperLink(link)
  })
}

document.addEventListener("turbo:load", applyTokenToWhitepaperLinks)
document.addEventListener("DOMContentLoaded", applyTokenToWhitepaperLinks)
document.addEventListener("click", (event) => {
  const link = event.target.closest("a")
  if (!link) return
  appendTokenToWhitepaperLink(link)
}, true)
